import React, { useEffect, useState } from 'react'

import { Col, DataContainer, Row } from 'Components/shared/Container'
import { H2, Text } from 'Components/shared/Typography'
import Input, { Checkbox } from 'Components/shared/Input'

import { SelectIcon } from 'Components/shared/Select'

const filteredKeys = (obj, filter) => {
  let key = []
  const keys = []
  for (key in obj)
    if (Object.prototype.hasOwnProperty.call(obj, key) && key.includes(filter)) keys.push(key)
  return keys
}

// TODO: The original one had horrible icon to value reference. need to fix that
const icons = [
  { text: 'FAQ', value: 13 },
  { text: 'Shopping', value: 1 },
  { text: 'Website', value: 2 },
  { text: 'Facebook', value: 3 },
  { text: 'Twitter', value: 4 },
  { text: 'Merchandise', value: 5 },
  { text: 'Tag', value: 6 },
  { text: 'Settings', value: 7 },
  { text: 'Diamond', value: 8 },
  { text: 'Pinterest', value: 9 },
  { text: 'YouTube', value: 10 },
  { text: 'Instagram', value: 11 },
  { text: 'News', value: 12 },
  { text: 'Calendar', value: 14 },
  { text: 'News', value: 15 },
  { text: 'Maps', value: 16 },
  { text: 'Videos', value: 17 },
  { text: 'Merchandise', value: 18 },
  { text: 'Signal', value: 19 },
  { text: 'Team', value: 20 }
]

export default ({ club, setSelectedClub, masterClub }) => {
  const [keys, setKeys] = useState([])

  useEffect(async () => {
    setKeys([])
    const filteredKey = club ? filteredKeys(club, 'menubtn') : ['menubtn1', 'menubtn2']
    setKeys(filteredKey)
  }, [masterClub])

  return (
    <>
      <DataContainer>
        <Row style={{ margin: '10px' }}>
          <H2>Menu Screen</H2>
        </Row>
        <Row>
          <Col style={{ width: '5%' }} />
          <Col style={{ width: '20%', alignItems: 'center' }}>
            <Text style={{ width: '125px' }}>Icon</Text>
          </Col>
          <Col style={{ width: '35.5%', alignItems: 'center' }}>
            <Text>Button Label</Text>
          </Col>
          <Col style={{ width: '35.5%', alignItems: 'center' }}>
            <Text>Button Link</Text>
          </Col>
        </Row>
        {keys.map((key, indx) => (
          <>
            <Row>
              {/* Enabled checkmark if more than three buttons */}
              <Col style={{ width: '5%' }}>
                {indx > 2 && (
                  <Checkbox
                    // If cmenu is true then it is not checked and form is disabled
                    checked={club[key]?.cmenu?._text !== 'true'}
                    onChange={e => {
                      setSelectedClub({
                        ...club,
                        [key]: { ...club[key], cmenu: { _text: (!e.target.checked).toString() } }
                      })
                    }}
                  />
                )}
              </Col>
              <Col style={{ width: '20%', alignItems: 'center' }}>
                <SelectIcon
                  xAlign="flex-start"
                  options={icons}
                  defaultIndex={club[key]?.icon?._text ? club[key]?.icon._text : 12}
                  disabled={indx > 2 && club[key]?.cmenu?._text === 'true'}
                  onChange={e => {
                    if (e.previousIndex === e.newIndex) return
                    setSelectedClub({
                      ...club,
                      [key]: { ...club[key], icon: { _text: icons[e.newIndex].value } }
                    })
                  }}
                  style={{ width: '125px' }}
                />
              </Col>
              <Col style={{ width: '35.5%', alignItems: 'center', margin: '10px' }}>
                <Input
                  value={club[key]?.title._text ? decodeURI(club[key]?.title._text) : ''}
                  fullWidth
                  disabled={indx > 2 && club[key].cmenu?._text === 'true'}
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      [key]: { ...club[key], title: { _text: e.target.value } }
                    })
                  }}
                />
              </Col>
              <Col style={{ width: '35.5%', alignItems: 'center', margin: '10px' }}>
                <Input
                  value={
                    club[key]?.url._text
                      ? decodeURI(club[key]?.url._text)
                          .replace(/[⁄]/gm, `/`)
                          .replace(/&amp;frasl;|&frasl;/g, '/')
                      : ''
                  }
                  fullWidth
                  disabled={indx > 2 && club[key]?.cmenu?._text === 'true'}
                  onChange={e => {
                    setSelectedClub({
                      ...club,
                      [key]: { ...club[key], url: { _text: e.target.value } }
                    })
                  }}
                />
              </Col>
            </Row>
          </>
        ))}
        <Row>
          <Col style={{ width: '5%' }}>
            <Checkbox
              checked={club.couponbtn?.showbtn?._text === 'true'}
              onChange={() => {
                const value = club.couponbtn?.showbtn?._text !== 'true'
                setSelectedClub({
                  ...club,
                  couponbtn: { ...club.couponbtn, showbtn: { _text: value.toString() } }
                })
              }}
            />
          </Col>
          <Col style={{ width: '20%', alignItems: 'center' }}>
            <Text>Resources</Text>
          </Col>
          <Col style={{ width: '75%', alignItems: 'center', margin: '10px' }}>
            <Input
              value={club.couponbtn?.title?._text ? decodeURI(club.couponbtn?.title._text) : ''}
              fullWidth
              disabled={club.couponbtn?.showbtn?._text !== 'true'}
              onChange={e => {
                setSelectedClub({
                  ...club,
                  couponbtn: { ...club.couponbtn, title: { _text: e.target.value } }
                })
              }}
            />
          </Col>
        </Row>
      </DataContainer>
    </>
  )
}
